import React from 'react'
import PropTypes from "prop-types"
import classnames from 'classnames/bind'

import Button from 'js/components/shared/Button'

import styles from './ItemCard.module.scss'

const cx = classnames.bind(styles)

const ItemCard = function ({ item }) {
  return (
    <div className={cx('root')}>
      <div className={cx('image-wrap')}>
        <img
          loading="lazy"
          src={item?.content?.picture?.src}
          alt={item?.content?.picture?.alt}
          srcSet={item?.content?.picture?.srcset}
          sizes={item?.content?.picture?.sizes}
          className={cx('image')}
        />
      </div>
      {(!item?.content?.picture?.sizes?.length || !item?.content?.picture?.srcset?.length) ? (
        <div className={cx('image-label')}>{item?.content?.defaultPictureText}</div>
        ) : (<div className={cx('image-label')} />
      )}
      {item?.name && <h4 className={cx('title')}>{item?.name}</h4>}
      {(!!item?.content?.description?.list?.length || !!item?.content?.description?.text?.length) && (
        <div className={cx('text-container')}>
          {!!item?.content?.description?.list?.length && (
            <div className={cx('list')}>
              {item.content.description.list.map(item => (
                <div
                  key={`${item?.code}-list-${item?.label}`}
                  className={cx('list-item')}
                >
                  {item?.label}
                </div>
              ))}
            </div>
          )}
          {!!item?.content?.description?.text?.length && (
            <div className={cx('text')}>{item.content.description.text}</div>
          )}
        </div>
      )}
      {!item?.content?.link?.disabled && (
        <Button
          data-amenity-code={item?.content?.link?.dataAttr?.['amenity-code']}
          data-hotel-id={item?.content?.link?.dataAttr?.['hotel-id']}
          href={item?.content?.link?.href}
          className={cx(item?.content?.link?.dataAttr?.class, {
            link: item?.content?.link?.type === 'link',
            button: item?.content?.link?.type === 'cta'
          })}
          tag="a"
        >
          {item?.content?.link?.linkText}
        </Button>
      )}
    </div>)
}

ItemCard.propTypes = {
  item: PropTypes.any,
}

export default ItemCard
